"use strict";
exports.__esModule = true;
exports.NumericOperator = exports.TriggerParamsValueType = exports.TimeTriggerUnitOfTime = exports.AlertSeverity = void 0;
var AlertSeverity;
(function (AlertSeverity) {
    AlertSeverity[AlertSeverity["Low"] = 1] = "Low";
    AlertSeverity[AlertSeverity["Medium"] = 2] = "Medium";
    AlertSeverity[AlertSeverity["High"] = 3] = "High";
})(AlertSeverity = exports.AlertSeverity || (exports.AlertSeverity = {}));
var TimeTriggerUnitOfTime;
(function (TimeTriggerUnitOfTime) {
    TimeTriggerUnitOfTime["MINUTES"] = "minutes";
    TimeTriggerUnitOfTime["HOURS"] = "hours";
    TimeTriggerUnitOfTime["DAYS"] = "days";
})(TimeTriggerUnitOfTime = exports.TimeTriggerUnitOfTime || (exports.TimeTriggerUnitOfTime = {}));
var TriggerParamsValueType;
(function (TriggerParamsValueType) {
    TriggerParamsValueType["ChangedTo"] = "ChangedTo";
    TriggerParamsValueType["ChangedBy"] = "ChangedBy";
})(TriggerParamsValueType = exports.TriggerParamsValueType || (exports.TriggerParamsValueType = {}));
var NumericOperator;
(function (NumericOperator) {
    NumericOperator["LESS_THAN"] = "LESS_THAN";
    NumericOperator["LESS_THAN_OR_EQUALS"] = "LESS_THAN_OR_EQUALS";
    NumericOperator["GREATER_THAN"] = "GREATER_THAN";
    NumericOperator["GREATER_THAN_OR_EQUALS"] = "GREATER_THAN_OR_EQUALS";
    NumericOperator["EQUALS"] = "EQUALS";
    NumericOperator["NOT_EQUALS"] = "NOT_EQUALS";
})(NumericOperator = exports.NumericOperator || (exports.NumericOperator = {}));
//# sourceMappingURL=alerts_configuration.js.map